/* eslint-disable import/prefer-default-export */
import {
  INFO_USER,
  LOGIN_USER,
} from '../types';

export const authUserAction = (sub) => ({
  type: LOGIN_USER,
  payload: sub,
});

export const authUserInfo = (infoUser) => ({
  type: INFO_USER,
  payload: infoUser,
});
